import React, { useMemo, useState } from "react";
import { FiChevronRight, FiChevronLeft } from "react-icons/fi";
// import NdisNews from "./NdisNews";
// import NdisPage from "./NdisPage";
import FeatureOfTheWeekTab from "./FeatureOfTheWeekTab";
import SystemNews from "./SystemNews";
import EventsTab from "./EventsTab";
import { isFeatureOfTheWeekDashboardFeedsEnabled } from "config/featureOfTheWeekFlags";

const Tab = () => {
  const tabs = useMemo(() => {
    const allTabs = [
      {
        id: "feature-of-the-week",
        title: "Feature of the Week",
        component: FeatureOfTheWeekTab,
      },
      { id: "system-news", title: "System News", component: SystemNews },
      { id: "events", title: "Events", component: EventsTab },
      // { id: "ndis-x", title: "NDIS On X", component: NdisNews },
      // { id: "ndis-facebook", title: "NDIS On Facebook", component: NdisPage },
    ];

    if (isFeatureOfTheWeekDashboardFeedsEnabled()) {
      return allTabs;
    }

    return allTabs.filter((tab) => tab.id !== "feature-of-the-week");
  }, []);

  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const handlePrevTab = () => {
    if (activeTabIndex > 0) {
      setActiveTabIndex(activeTabIndex - 1);
    }
  };

  const handleNextTab = () => {
    if (activeTabIndex < tabs.length - 1) {
      setActiveTabIndex(activeTabIndex + 1);
    }
  };
  return (
    <div className="w-full">
      <div className="mb-4">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-1 h-6 bg-gradient-to-b from-indigo-500 to-purple-500 rounded-full"></div>
          <h3 className="text-lg font-bold text-gray-900">Feeds</h3>
        </div>
        {tabs.length > 1 && (
          <div className="flex border-b border-gray-200 bg-gray-50 rounded-t-lg overflow-hidden">
            {tabs.map((tab, index) => (
              <button
                key={tab.id}
                type="button"
                className={`
                min-w-0 flex-1 px-1.5 py-2.5 text-center font-semibold leading-tight
                text-xs sm:text-sm lg:text-xs xl:text-sm
                transition-all duration-200 relative break-words
                ${
                  activeTabIndex === index
                    ? "text-blue-600 bg-white border-b-2 border-blue-500"
                    : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
                }
              `}
                onClick={() => setActiveTabIndex(index)}
              >
                {tab.title}
                {activeTabIndex === index && (
                  <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-blue-500 to-cyan-500"></div>
                )}
              </button>
            ))}
          </div>
        )}
      </div>

      <div
        className={`bg-white border border-gray-200 overflow-hidden ${
          tabs.length > 1 ? "rounded-b-lg" : "rounded-lg"
        }`}
      >
        {tabs.map((tab, index) => {
          const TabComponent = tab.component;
          return (
            <div
              key={tab.id}
              className={`${
                activeTabIndex === index ? "block animate-fadeIn" : "hidden"
              }`}
            >
              <div className="min-w-0 max-h-[500px] overflow-x-hidden overflow-y-auto p-3 sm:p-4 lg:p-3 xl:p-4 custom-scroll">
                {activeTabIndex === index && <TabComponent />}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Tab;
